import { APIPaymentMethodModel } from "../../../Models/API/BillingModel"
import { getPaymentMethodsList } from "../../../Actions/API/BillingActions"
import { createProvider } from "../Common/Provider"

export const PaymentMethodListProvider = createProvider<
    APIPaymentMethodModel[],
    {}
>(state => state.api.billing.paymentMethod.list, getPaymentMethodsList)
